document.addEventListener('DOMContentLoaded', function() {
    function updateProductImage(card, variantData, variantId) {
        let productImageElement = card.querySelector('.card__media img');
        if (productImageElement) {
            let lazyLoadAllVariants = card.getAttribute('data-lazy-load-all-variants') === 'true';
            if (lazyLoadAllVariants) {
                let preloadedImage = card.querySelector(`img[data-variant-id="${variantId}"]`);
                if (preloadedImage) {
                    productImageElement.src = preloadedImage.src;
                    productImageElement.srcset = preloadedImage.srcset;
                }
            } else if (variantData && variantData.imageUrl) {
                let baseUrl = variantData.imageUrl.split('?')[0];
                let imageWidth = parseInt(productImageElement.getAttribute('width')) || 0;
                let dynamicSrcset = [];
                if (imageWidth >= 1066) {
                    dynamicSrcset.push(`${baseUrl}?width=1066 1066w`);
                }
                if (imageWidth > 0) {
                    dynamicSrcset.push(`${baseUrl} ${imageWidth}w`);
                }
                productImageElement.srcset = dynamicSrcset.join(', ');
                productImageElement.src = `${baseUrl}?width=1000`;
            }
        }
    }

    function updateProductLinks(card, variantData) {
        let productLinks = card.querySelectorAll('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"], a.card__content');
        productLinks.forEach(function(link) {
            link.href = variantData.productUrl;
        });

        if (variantData.productUrl) {
            let quickAddButton = card.querySelector('.quick-add__submit');
            if (quickAddButton) {
                quickAddButton.setAttribute('data-product-url', variantData.productUrl);
            }
        }
    }

    function storeSelectedVariant(sectionId, productId, variantId) {
        sessionStorage.setItem('selectedVariant-' + sectionId + '-' + productId, variantId);
    }

    function storeSelectedSwatch(sectionId, productId, variantId) {
        sessionStorage.setItem('selectedSwatch-' + sectionId + '-' + productId, variantId);
    }

    function restoreSelectedVariant(productGrid, sectionId, productId, variantDataMap) {
        let selectedVariantId = sessionStorage.getItem('selectedVariant-' + sectionId + '-' + productId);
        if (selectedVariantId && variantDataMap[selectedVariantId]) {
            let card = productGrid.querySelector(`.card-product-custom-div[data-section-id="${sectionId}"][data-product-id="${productId}"]`);
            let variantData = variantDataMap[selectedVariantId];
            updateProductImage(card, variantData, selectedVariantId);
            updateProductLinks(card, variantData);
        }
    }

    function restoreSelectedSwatch(productGrid, sectionId, productId) {
        let selectedVariantId = sessionStorage.getItem('selectedSwatch-' + sectionId + '-' + productId);
        if (selectedVariantId) {
            let swatchInput = productGrid.querySelector(`input[type="radio"][data-variant-id="${selectedVariantId}"][data-section-id="${sectionId}"][data-product-id="${productId}"]`);
            if (swatchInput) {
                swatchInput.checked = true;
            }
        }
    }

    function initializeProductGrid(productGrid) {
        let sectionId = productGrid.getAttribute('data-id');
        productGrid.querySelectorAll('.card-product-custom-div').forEach(function(card) {
            let productId = card.getAttribute('data-product-id');
            let variantDataMap = window['variantDataMap' + sectionId.replace(/-/g, '_') + '_' + productId];
            restoreSelectedVariant(productGrid, sectionId, productId, variantDataMap);
            restoreSelectedSwatch(productGrid, sectionId, productId);
            card.addEventListener('change', function(e) {
                if (e.target.matches('input[type="radio"][data-section-id="' + sectionId + '"][data-product-id="' + productId + '"]')) {
                    let variantId = e.target.getAttribute('data-variant-id');
                    let variantData = variantDataMap[variantId];
                    if (!variantData) {
                        return;
                    }
                    storeSelectedVariant(sectionId, productId, variantId);
                    storeSelectedSwatch(sectionId, productId, variantId);
                    updateProductImage(card, variantData, variantId);
                    updateProductLinks(card, variantData);
                }
            });
            card.classList.add('loaded');
        });
    }

    function initializeAllProductGrids() {
        let productGrids = document.querySelectorAll('.grid.product-grid');
        productGrids.forEach(initializeProductGrid);
    }

    initializeAllProductGrids();

    let observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                initializeAllProductGrids();
            }
        });
    });

    let config = { childList: true, subtree: true };
    observer.observe(document.body, config);
});
